export default __webpack_public_path__ + "213f8a11d0389d829744e758afd67889.ico";